<template>
  <div class="page-column">
     <div class="header">
        <div class="title">
            <div class="han">机构榜</div>
            <div class="eng">Club Rankings</div>
        </div>
        <div class="search">
            <input class="search-input" type="text" placeholder="请输入机构名称搜索" v-model="searchVal">
            <img class="search-icon" src="../../../assets/search_icon.png" alt="" @click="search()">
        </div>
        <div class="option">
            <a-icon type="environment" />
            <a-select style="width:150px; margin: 0 10px;" placeholder="请选择地区" @change="handleChange">
                <a-select-option v-for="(item, index) in address" :key="index" :value="item.value">
                    {{ item.label }}
                </a-select-option>
            </a-select>
            <a-icon type="menu-fold" />
            <a-select style="width:150px;margin: 0 10px;" placeholder="请选择机构类型" @change="handleChangeAgency">
                <a-select-option v-for="(item, index) in agencyTypeList" :key="index" :value="item.code">
                    {{ item.name }}
                </a-select-option>
            </a-select>
        </div>
     </div>
     <div class="content">
         <div class="table-header" >
             <div class="header-list" v-for="(header,index) in header" :key="index">
                 <div class="header-txt" v-if="header.type == 'txt'">{{header.value}}</div>
                 <div class="header-img" v-if="header.type == 'img'"><img :src="header.value" alt="" style="width:100%;height:100%"></div>
             </div>
         </div>
         <div class="table-body">
             <div class="body-list" v-for="(player,index) in playerList" :key="index" :class="isOdd(index) ? '':'bg-F4F4F4' ">
                 <div class="index flx-1" >
                   <img class="rank-bg" :src="getRankBg(index)" alt="" v-if="handleIndex(index) < 4">
                   <span class="index-txt">{{handleIndex(index)}}</span>
                  </div>
                 <div class="player flx-1" >
                   <img class="player-head" :src="player.unitlogo" alt="">
                   <span>{{player.unitName}}</span>
                  </div>
                 <!-- <div class="agency flx-1" >{{player.unitName}}</div> -->
                 <div class="region flx-1" >{{player.areaName}}</div>
                 <div class="counts flx-1" >{{ getAgnecyTypeTxt(player.unitType) }}</div>
                 <div class="gold flx-1" >{{player.gold}}</div>
                 <div class="sliver flx-1" >{{player.silver}}</div>
                 <div class="bronze flx-1" >{{player.bronze}}</div>
                 <div class="total-score flx-1" >{{player.score}}</div>
             </div>
              <div class="pages" v-if="playerList.length !==0">
                <a-pagination v-model="current" :total="totalNum" :defaultPageSize="params.pageSize" show-less-items @change="onChange"/>
              </div>
         </div>
     </div>

  </div>
</template>

<script>
import address from '@comm/utils/address'
import matchFun from '@comm/utils/matchFun.js'
export default {
  data () {
    return {
      address: address,
      header: [
        {type: 'txt', value: '排名'},
        // {type: 'txt', value: '运动员'},
        {type: 'txt', value: '机构'},
        {type: 'txt', value: '地区'},
        // {type: 'txt', value: '胜/负场'},
        {type: 'txt', value: '类型'},
        {type: 'img', value: require('@comm/assets/jin.png')},
        {type: 'img', value: require('@comm/assets/yin.png')},
        {type: 'img', value: require('@comm/assets/tong.png')},
        // {type: 'txt', value: '第五名'},
        {type: 'txt', value: '总积分'}
      ],
      rankBgList: [
        {index: 0, src: require('@comm/assets/gold_bg.png')},
        {index: 1, src: require('@comm/assets/sliver_bg.png')},
        {index: 2, src: require('@comm/assets/bronze_bg.png')}
      ],
      params: {
        programId: this.$route.query.programId,
        pageNum: 1,
        pageSize: 20,
        name: -1,
        province: -1,
        year: -1,
        type: -1
      },
      matchFun: matchFun,
      agencyTypeList: [],
      searchVal: null,
      totalNum: 569,
      series: 21,
      dependent: 537,
      sportsMeeting: 10,
      activeStatus: 0,
      current: 1,
      playerList: []
    }
  },
  created () {
    window.scrollTo(0, 0)
    this.loadData()
    this.handleAllOperation()
  },
  methods: {
    handleIndex (index) {
      // console.log('111', this.params.pageNum, (this.params.pageNum - 1) * this.params.pageSize + index + 1)
      return (this.params.pageNum - 1) * this.params.pageSize + index + 1
    },
    getAgnecyTypeTxt (type) {
      let result = ''
      this.agencyTypeList.forEach(agency => {
        if (agency.code == type) {
          result = agency.name
        }
      })
      return result
    },
    handleAllOperation () {
      let result = this.address.some(e => {
        if (e.value == '-1') {
          return true
        }
      })
      if (!result) {
        this.address.unshift({'value': '-1', 'label': '全部', 'children': []})
      }
      this.agencyTypeList = this.matchFun.agencyTypeEnum()
      let res = this.agencyTypeList.some(f => {
        if (f.code == -1) {
          return true
        }
      })
      if (!res) {
        this.agencyTypeList.unshift({'code': -1, 'name': '全部'})
      }
    },
    onChange (page, pageSize) {
      this.params.pageNum = page
      this.loadData()
    },
    getRankBg (index) {
      let src = ''
      this.rankBgList.forEach(rank => {
        if (rank.index == index) {
          src = rank.src
        }
      })
      return src
    },
    getWinRate (win, total) {
      if (total == 0) {
        return '暂无数据'
      } else {
        return (Number(win / total) * 100).toFixed(2) + '%'
      }
    },
    isOdd (index) {
      if ((index + 1) % 2 == 1) {
        return true
      } else {
        return false
      }
    },
    handleChange (value) {
      this.params.province = value
      this.loadData()
    },
    handleChangeAgency (value) {
      this.params.type = value
      this.loadData()
    },
    search () {
      if (this.searchVal !== '' && this.searchVal !== undefined && this.searchVal !== null) {
        this.params.name = this.searchVal
        this.loadData()
      }
    },
    loadData () {
      // console.log('this.params', this.params)
      this.$api.match.getAgencyRank(this.params).then(res => {
        // console.log('getAgencyRank', res)
        if (res.status == 0) {
          this.playerList = res.data
          this.totalNum = res.total
          // 将搜索关键词清空
          this.params.name = -1
          this.searchVal = ''
        }
      }).catch(err => {
        console.log('err', err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  margin: 70px auto;
  // position: relative;
  // background-color: green;
}
.header{
  width: 1200px;
  padding: 30px 0 20px 0;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.search{
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  // background-color: green;
}
.search-input{
  width: 271px;
  padding-left: 50px;
  border: 0px;
  outline: none;
  border-bottom: 1px solid #b3b3b3;
  font-size: 13px;
}
.search-icon{
  width: 17px;
  height: 17px;
}
.body{
  width: 100%;
  padding: 10px calc(50% - 600px);
  background-color: #EEE;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.han{
  font-size: 30px;
  margin-right: 10px;
  font-weight: bold ;
}
.eng{
  font-size: 20px;
}
.title{
 flex: 1;
  height: 31px;
  color: #333;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  // margin-bottom: 47px;
}
.option{
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
}
.content{
    width: 1200px;
    margin: 10px auto;
    // position: relative;
}
.table-header{
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: #B01F24;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.table-body{
    width: 100%;
    height: 50px;
    line-height: 50px;
    // background: #B01F24;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}
.header-list{
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.flx-1{
    flex: 1;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: row;
    overflow: hidden;
    white-space: nowrap;
}
.body-list{
    width: 100%;
    // padding: 8px 0;
    // box-sizing: content-box;
    // flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    font-weight: bold;
}
.header-txt{
    color: #fff;
    font-size: 15px;
    font-weight: bold;
}
.header-img{
    width: 30px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.bg-F4F4F4{
  background-color: #F4F4F4;
}
.player-head{
  width: 44px;
  height: 44px;
  border-radius: 8px;
  margin-right: 13px;
}
.player{
  // display: flex;
  // flex-direction: row;
  justify-content: flex-start !important;
}
.index{
  position: relative;
  height: 70px;
  display: flex;
  align-items: center;
}
.rank-bg{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.index-txt{
  z-index: 2;
}
.pages{
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
  overflow: hidden;
  // background-color: #EEE;
  display: flex;
  justify-content: center;
  // position: relative;
  // bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/event/clubRanking/ClubRanking.vue